
import type { ExternalEvent } from '../types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export const eventIntegrationService = {
    /**
     * Searches for events using the Outside/BikeReg GraphQL API.
     */
    searchEvents: async (searchTerm: string): Promise<ExternalEvent[]> => {
        try {
            const searchExternalEvents = httpsCallable(functions, 'searchExternalEvents');
            const result = await searchExternalEvents({ searchTerm });
            return result.data as ExternalEvent[];
        } catch (error) {
            console.error("Failed to search events", error);
            throw error;
        }
    }
};
